import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { childrenApi } from "../../api/endpoints.js";
import { AdultScreen, AdultHeader, Content } from "../../components/Layout.js";
import { Card } from "../../components/Card.js";
import { Button } from "../../components/Button.js";
import { Field, TextInput, ErrorBanner } from "../../components/Form.js";
import { useT } from "../../i18n/index.js";
import { mensajeDeError } from "../../hooks/useQuery.js";

export function NewChildPage() {
  const t = useT();
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [fechaNacimiento, setFecha] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(ev: FormEvent) {
    ev.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      const nino = await childrenApi.crear({ nombre, fechaNacimiento });
      // Tras registrar, encaminamos al flujo de consentimientos del peque.
      navigate(`/padre/nino/${nino.id}/consentimientos`, { replace: true });
    } catch (e) {
      setError(mensajeDeError(e));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AdultScreen>
      <AdultHeader title={t("child.new.title")} />
      <Content>
        <Card>
          <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {error ? <ErrorBanner message={error} /> : null}
            <Field label={t("child.new.name")}>
              <TextInput required value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </Field>
            <Field label={t("child.new.birthdate")}>
              <TextInput
                type="date"
                required
                value={fechaNacimiento}
                onChange={(e) => setFecha(e.target.value)}
              />
            </Field>
            <Button type="submit" block disabled={enviando}>
              {enviando ? t("common.saving") : t("child.new.submit")}
            </Button>
          </form>
        </Card>
        <Link to="/padre" style={{ textAlign: "center" }}>
          {t("common.back")}
        </Link>
      </Content>
    </AdultScreen>
  );
}
